<template>
  <div class="legislacao">
    <div class="container">
      <h1 class="display-1 my-3">Guia de Utilização da API Municipal</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-3">
        <v-flex xs12 sm9 class="mb-4 px-8">
          <p class="subtitle-2 grey--text text-justify">
            {{ messageDescritivoWebServiceLote }}
          </p>
          <!--          <p class="headline">Integração entre sistemas via webservice</p>-->
          <!--          <p class="grey&#45;&#45;text">-->
          <!--            {{ messageDescritivoIntegracaoWebServiceLote }}-->
          <!--          </p>-->

          <div>
            <v-btn
                outlined
                small
                :color="mostrarPainelProducao ? 'primary' : ''"
                :class="{ 'primary--text': mostrarPainelProducao }"
                @click="mostrarPainelProducao = !mostrarPainelProducao; mostrarPainelHomologacao = false">
              API - Produção
            </v-btn>

            <v-btn
                outlined
                small
                class="ml-2"
                :color="mostrarPainelHomologacao ? 'primary' : ''"
                :class="{ 'primary--text': mostrarPainelHomologacao }"
                @click="mostrarPainelHomologacao = !mostrarPainelHomologacao; mostrarPainelProducao = false">
              API - Homologação
            </v-btn>
          </div>

          <v-expand-transition>
            <v-card v-show="mostrarPainelProducao" class="mt-2 mb-3">
              <v-card-text v-html="linkWebserviceProducao">
              </v-card-text>
            </v-card>
          </v-expand-transition>

          <v-expand-transition>
            <v-card v-show="mostrarPainelHomologacao" class="mt-2">
              <v-card-text v-html="linkWebserviceHomologacao">
              </v-card-text>
            </v-card>
          </v-expand-transition>
        </v-flex>

        <v-flex xs12 sm3>
          <h2 class="title font-weight-font-weight-font-italic"> Documentação Técnica</h2>
          <v-divider></v-divider>
          <p class="grey--text body-2">
            Acesse os arquivos técnicos necessários para integração com a API de emissão de NFS-e.
          </p>
          <!-- <v-btn
            text
            small
            outlined
            color="primary"
            target="_blank"
            @click="baixarPDF"
            >baixar</v-btn
          >-->
          <v-btn
              text
              small
              outlined
              color="primary"
              target="_blank"
              block
              :href="linkManualIntegracao">
            Baixar Esquemas XSD
          </v-btn>

          <v-spacer class="my-5"/>

          <v-btn
              text
              small
              outlined
              color="primary"
              target="_blank"
              block
              :href="linkAnexosLayout">
            Baixar Anexos de Layout
          </v-btn>
        </v-flex>
        
        <v-flex xs12 md12 class="mb-4 px-8">
          <h2 class="headline">Orientações Adicionais</h2>
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <pre>
                  <p class="grey--text">{{ textoExplicativoWebService }}</p>
                </pre>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout></v-layout>
    </div>
  </div>
</template>

<script>
import EventService from "../services/EventService";

export default {
  props: {
    textoExplicativoWebService: {
      type: String,
    },
  },
  data() {
    return {
      mostrarPainelHomologacao: false,
      mostrarPainelProducao: false,
      opcoesApiProducao: [],
      opcoesApiHomologacao: [],
      linkManualIntegracao: "",
      linkAnexosLayout: "",
      linkWebserviceHomologacao: "",
      linkWebserviceProducao: "",
      messageDescritivoWebServiceLote: "",
      messageDescritivoIntegracaoWebServiceLote: ""
    };
  },
  methods: {
    baixarPDF() {
      let pdf = this.linkManualIntegracao;
      let dataURI = "data:application/pdf;base64," + pdf;
      // window.open(dataURI);
      let link = document.createElement("a");
      link.download = "manualIntegracao.pdf";
      link.href = dataURI;
      link.textContent = "Baixar PDF";
      link.click();
      document.body.appendChild(link);
    },
  },
  created() {
    EventService.getConteudo().then((response) => {
      this.linkManualIntegracao = response.data.linkManualIntegracao;
      this.linkAnexosLayout = response.data.linkAnexosLayout;
      this.linkWebserviceHomologacao = response.data.linkAcessoWSHomologacao;
      this.linkWebserviceProducao = response.data.linkAcessoWSProducao;
      console.log(this.linkManualIntegracao);
    });

    EventService
        .getBundle("message.portalDescritivoWebServiceLote")
        .then(res => this.messageDescritivoWebServiceLote = res.data)

    EventService
        .getBundle("message.portalDescritivoIntegracaoWebServiceLote")
        .then(res => this.messageDescritivoIntegracaoWebServiceLote = res.data)
  },
};
</script>
